import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
} from '@mui/material';

function ApercuINSBU() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '40px' }}>
      <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '60px' }}>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Aperçu de l'INSBU
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          L’Institut National de la Statistique du Burundi (INSBU) est un établissement public à caractère administratif (EPA) qui joue un rôle central dans le domaine de la statistique au Burundi. Doté de la personnalité juridique et de l’autonomie financière, l'INSBU est placé sous l’autorité hiérarchique du Ministre des Finances, du Budget et de la Planification Économique, intervenant dans les missions liées à la statistique.
        </Typography>

        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Missions de l’INSBU
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          En tant qu'Autorité Statistique Nationale, l’INSBU assure la coordination technique des activités du Système Statistique National (SSN). Ses missions se déclinent en plusieurs responsabilités clés :
        </Typography>
        
        <ul>
          <li><strong>Coordination et Secrétariat :</strong> L'INSBU assure le Secrétariat technique permanent du Comité National de l’Information Statistique (CNIS) et préside le Comité Technique de l’Information Statistique (CTIS).</li>
          <li><strong>Productions Statistiques :</strong> Il réalise des travaux statistiques d’envergure nationale, notamment des recensements et des enquêtes, permettant d'obtenir des données précises et exploitables.</li>
          <li><strong>Collecte et Diffusion des Données :</strong> L’INSBU collecte, traite, analyse, produit, publie, diffuse, archive et sécurise les données statistiques nécessaires à l’élaboration, au suivi et à l’évaluation des politiques et stratégies de développement dans tous les domaines de la vie nationale.</li>
          <li><strong>Méthodologie Statistique :</strong> L'institut veille à l'application des méthodes, concepts, définitions, normes et classifications approuvés par le CNIS, garantissant ainsi la qualité et la fiabilité des données produites.</li>
          <li><strong>Formation et Recherche :</strong> L'INSBU promeut la formation initiale et continue du personnel spécialisé dans le fonctionnement du SSN et favorise le développement de la recherche appliquée dans ses domaines d'expertise.</li>
        </ul>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Sous la supervision de l’Autorité Ministérielle, l’INSBU est également chargé de suivre la coopération technique internationale en matière statistique. Il représente le Burundi lors des réunions sous-régionales, régionales et internationales et veille à la mise en application des recommandations issues de ces rencontres.
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          De plus, l’INSBU peut, sur demande du Gouvernement et des administrations publiques ou privées, entreprendre des études et recherches statistiques, qu'elles soient à titre onéreux ou gracieux. Ces collaborations s'accompagnent de la signature de contrats de service ou de protocoles d'accord, garantissant ainsi une transparence et une clarté dans les engagements pris.
        </Typography>

       
      </Container>
      <Footer />
    </div>
  );
}

export default ApercuINSBU;